
















import {
  defineComponent,
} from '@nuxtjs/composition-api';

import { useUiHelpers } from '~/composables';
import type {
  CategoryTree,
} from '~/modules/GraphQL/types';
import type { PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CategorySubSubChildFilters',
  props: {
    childCategory: {
      type: Object as PropType<CategoryTree>,
      required: true,
    },
    activeCategoryValidator: {
      type: Function as PropType<(uid: string) => boolean>,
      default: () => () => false,
    },
  },
  setup() {
    const { getCatLink } = useUiHelpers();

    return {
      getCatLink,
    };
  },
});
